<template>
    <PortalAbonadosSga v-if="teatro.sga" />
    <PortalAbonadosAvet v-else />
</template>

<script>

    import PortalAbonadosAvet from '@/components/frontend/lfp/PortalAbonadosAvet.vue';
    import PortalAbonadosSga from '@/components/frontend/lfp/PortalAbonadoSga.vue';
    import { useHead } from '@/composables/common/seo/useHead';

    export default {
        components: {
            
            PortalAbonadosAvet,
            PortalAbonadosSga
        },
        created() {
            useHead('Mi abono');
            if (!(this.footer.lfp === 1 && this.teatro.sga === 0)) {
                this.$router.push('/');
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            footer() {
                return this.$store.getters.getFooter;
            }
        }
    }
</script>